import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from './components/utils/translation/en.json'
import fr from './components/utils/translation/fr.json'

i18n.use(initReactI18next).init({
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    resources: {    
      en: {
        translation: en
      },
      fr: {
        translation: fr
      },
    },
});

export default i18n;